import { isEmpty } from 'mc-ui-utils';
export const startPendingProgressBarAnimation = (glanceId, duration) => {
    const progressBar = document.querySelector(`.progress[data-card="${glanceId}"]`);
    if (!isEmpty(progressBar)) {
        requestAnimationFrame(() => {
            progressBar.style.animationDuration = `${duration}ms`;
            progressBar.style.animationPlayState = `running`;
        });
    }
};
export const toggleProgressBar = (glanceId, state) => {
    const progressBar = document.querySelector(`.progress[data-card="${glanceId}"]`);
    if (!isEmpty(progressBar)) {
        requestAnimationFrame(() => {
            progressBar.style.animationPlayState = state;
        });
    }
};
//# sourceMappingURL=progressbarhelper.js.map